import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getWorkOrders: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDERS,
	},
	getWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER,
	},
	createWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_WORK_ORDER,
	},
	createFieldWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_FIELD_WORK_ORDER,
	},
	putWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_WORK_ORDER,
	},
	putCloseFieldWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_FIELD_WORK_ORDER,
	},
	putUpdateFieldWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_FIELD_WORK_ORDER,
	},
	patchWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER,
	},
	patchCloseFieldWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_FIELD_WORK_ORDER,
	},
	patchUpdateFieldWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_FIELD_WORK_ORDER,
	},
	deleteWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].DELETE_WORK_ORDER,
	},
	getWorkOrderPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_PREVIEW,
	},
	getWorkOrderPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_POPUP,
	},
	patchWorkOrderRecalculate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_WORK_ORDER_RECALCULATE,
	},
	getWorkOrderIsCanBeClosed: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].GET_WORK_ORDER_IS_CAN_BE_CLOSED,
	},
	createLogisticWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_LOGISTIC_WORK_ORDER,
	},
	putCloseLogisticWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_CLOSE_LOGISTIC_WORK_ORDER,
	},
	putUpdateLogisticWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PUT_UPDATE_LOGISTIC_WORK_ORDER,
	},
	patchCloseLogisticWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_CLOSE_LOGISTIC_WORK_ORDER,
	},
	patchUpdateLogisticWorkOrder: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_UPDATE_LOGISTIC_WORK_ORDER,
	},
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].CREATE_HAND_MADE_WORK_ORDER,
	},
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].PATCH_HAND_MADE_WORK_ORDER,
	},
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_BRIGADE,
	},
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PERIOD,
	},
	[ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK]: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS].COPY_TO_ANOTHER_PLAN_WORK,
	},
}
